import React from "react";
import {
    Box,
    Typography, Stepper as StepperMUI,
    Step,
    StepLabel,
    StepConnector
} from "@mui/material";
import StepIcon from "./StepIcon";

export default function Stepper({ steps }) {
    return (
        <StepperMUI
            alternativeLabel
            activeStep={2}
            connector={
                <StepConnector
                    sx={{
                        marginTop: "68px",
                        left: "calc(-50% + 25px)",
                        right: "calc(50% + 25px)",
                    }}
                />
            }
        >
            {steps.map((label, index) => (
                <Step key={label}>
                    <StepLabel
                        StepIconComponent={StepIcon}
                        style={{ flexDirection: "column-reverse", gap: 20 }}
                    >
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "column-reverse",
                                alignItems: "center",
                            }}
                        >
                            <Typography variant="body2" color={index === 2 ? "#0C326F" : index < 2 ? "green" : "grey"} fontWeight="bold">
                                {label}
                            </Typography>
                        </Box>
                    </StepLabel>
                </Step>
            ))}
        </StepperMUI>
    );
}